module.exports = require("leaflet");


//////////////////
// WEBPACK FOOTER
// external "leaflet"
// module id = 4
// module chunks = 0